module.exports = __webpack_public_path__ + "images/emoji/point_up_2.90ecea93c20ab2b69ff4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/point_up_2.png
// module id = NKWd
// module chunks = 2